import TableHeader from './TableHeader';
import TableBody from './TableBody';
import {
  CheckboxDefinitionType,
  ColumnDefinitionType,
  MoreButtonDefinitionType,
  OptionsType
} from './genericTableTypes';
import * as Styled from './style';

type TableProps<T, K extends keyof T> = {
  id?: string;
  typeTutorial?: string;
  data: T[];
  theme?: string;
  columns: ColumnDefinitionType<T, K>[];
  moreButton?: MoreButtonDefinitionType;
  equipmentSpecificOptions?: OptionsType[];
  additionalOptionsPosition?: number;
  shouldApplyOptions?: (equipType: string | undefined) => boolean;
  checkboxAll?: boolean
  checkbox?: CheckboxDefinitionType;
  onOrderTable: (columnName: K) => void;
  onRowClicked?: (id: number) => void;
  showMobileHeaders?: boolean;
  isReording?: boolean;
  clickUpdate?: (id: number, typeOptions?: string) => void;
  clickType?: (type: string) => void;
  className?: string;
  onReorder?: (newOrder: any[]) => void;
};

const GenericTable = <T extends { id: number }, K extends keyof T>({
  id,
  typeTutorial,
  data,
  columns,
  theme,
  moreButton = { show: false, options: [] },
  equipmentSpecificOptions = [],
  additionalOptionsPosition = 1,
  shouldApplyOptions = () => false,
  checkboxAll,
  checkbox = { show: false, action: () => { }, selectedList: [] },
  onOrderTable,
  onRowClicked = () => { },
  showMobileHeaders = false,
  isReording = false,
  onReorder,
  clickUpdate,
  clickType,
  className
}: TableProps<T, K>) => {
  return (
    <Styled.Table id={id}>
      <TableHeader
        id={id}
        columns={columns}
        onFilterClick={onOrderTable}
        checkboxAll={checkboxAll}
        checkbox={checkbox}
        showCheckbox={checkbox.show}
        showMoreButton={moreButton.show}
        className={className}
      />
      <TableBody
        id={id}
        className={className}
        typeTutorial={typeTutorial}
        data={data}
        columns={columns}
        theme={theme}
        moreButton={moreButton}
        equipmentSpecificOptions={equipmentSpecificOptions}
        additionalOptionsPosition={additionalOptionsPosition}
        shouldApplyOptions={shouldApplyOptions}
        checkbox={checkbox}
        onRowClicked={onRowClicked}
        showMobileHeaders={showMobileHeaders}
        isReording={isReording}
        onReorder={onReorder}
        clickUpdate={clickUpdate}
        clickType={clickType}
      />
    </Styled.Table>
  );
};

export default GenericTable;
